export const searchingForGroupOptions = [
  { value: 0, label: "Actively looking for a writing group" },
  {
    value: 1,
    label: "Open to additional writing partners if it's the right fit",
  },
  { value: 2, label: "Not looking at this time" },
];